// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tag-module__root--Tt2oT {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline: 10px;
  border: 1px solid var(--tag-border-color);
  border-radius: 999px;
  background: var(--tag-background);
  color: var(--tag-color);
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
}

.Tag-module__variant-default--eUm9W {
  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */
}

.Tag-module__variant-primary--YzkoC {
  --tag-background: #1a1a1a;
  --tag-border-color: #1a1a1a;
  --tag-color: #fff;
}

.Tag-module__variant-ghost--z2fgz {
  --tag-background: transparent;
  --tag-border-color: transparent;
  --tag-color: #666;
}

.Tag-module__variant-subtle--LxCpu {
  --tag-background: #eee;
  --tag-border-color: transparent;
  --tag-color: #666;
}

.Tag-module__size-small--d5KQk {
  height: 18px;
  font-size: 0.625rem; /* 10px */
}

.Tag-module__size-medium--I8Ukj {
  height: 20px;
  font-size: 0.6875rem; /* 11px */
}

.Tag-module__size-large--N1Rc0 {
  height: 24px;
  font-size: 0.75rem; /* 12px */
}

.Tag-module__label--u92VD {
  padding-bottom: 1px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Tag/Tag.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yCAAyC;EACzC,oBAAoB;EACpB,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,YAAY;EACZ,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-inline: 10px;\n  border: 1px solid var(--tag-border-color);\n  border-radius: 999px;\n  background: var(--tag-background);\n  color: var(--tag-color);\n  font-weight: 600;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.variant-default {\n  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */\n}\n\n.variant-primary {\n  --tag-background: #1a1a1a;\n  --tag-border-color: #1a1a1a;\n  --tag-color: #fff;\n}\n\n.variant-ghost {\n  --tag-background: transparent;\n  --tag-border-color: transparent;\n  --tag-color: #666;\n}\n\n.variant-subtle {\n  --tag-background: #eee;\n  --tag-border-color: transparent;\n  --tag-color: #666;\n}\n\n.size-small {\n  height: 18px;\n  font-size: 0.625rem; /* 10px */\n}\n\n.size-medium {\n  height: 20px;\n  font-size: 0.6875rem; /* 11px */\n}\n\n.size-large {\n  height: 24px;\n  font-size: 0.75rem; /* 12px */\n}\n\n.label {\n  padding-bottom: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Tag-module__root--Tt2oT`,
	"variant-default": `Tag-module__variant-default--eUm9W`,
	"variant-primary": `Tag-module__variant-primary--YzkoC`,
	"variant-ghost": `Tag-module__variant-ghost--z2fgz`,
	"variant-subtle": `Tag-module__variant-subtle--LxCpu`,
	"size-small": `Tag-module__size-small--d5KQk`,
	"size-medium": `Tag-module__size-medium--I8Ukj`,
	"size-large": `Tag-module__size-large--N1Rc0`,
	"label": `Tag-module__label--u92VD`
};
export default ___CSS_LOADER_EXPORT___;
